export default __webpack_public_path__ + "static/media/Open Attendances.2bc6ec38.svg";